<template>
	<div class="wrapper">
		<button
			type="button"
			class="form-control btn-dark"
			data-toggle="modal"
			data-target="#reportModal"
		>
			Music report
		</button>
		<div
			class="modal fade"
			id="reportModal"
			tabindex="-1"
			role="dialog"
			aria-labelledby="reportModalTitle"
			aria-hidden="true"
		>
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="reportModallTitle">
							Music report
						</h5>
						<date-picker
							updateOnInput
							ref="calendar"
							v-model="dates"
							mode="range"
							:popover="{
								placement: 'bottom',
								visibility: 'click',
							}"
							@input="changeDateEvent"
						>
							<button
								type="button"
								class="btn btn-outline-secondary dates-btn ml-3 float-right"
								v-bind:class="{ active: hasDates }"
							>
								<span v-if="hasDates">
									<fa-icon icon="calendar-alt"></fa-icon>
									{{ dateFrom }} - {{ dateTo }}
								</span>
								<fa-icon v-else icon="calendar-alt"></fa-icon>
							</button>
						</date-picker>
					</div>
					<div class="modal-body" v-if="songs && songs.length">
						<table
							ref="songsTable"
							class="table story-listing"
							data-cols-width="50,20"
						>
							<caption></caption>
							<thead class="thead-light">
								<tr data-height="20">
									<th
										data-f-bold="true"
										data-fill-color="000"
										data-f-color="FFFFFF"
										scope="col"
									>
										Total runtime all songs:
									</th>
									<th
										data-f-bold="true"
										data-fill-color="000"
										data-f-color="FFFFFF"
										scope="col"
										class="text-center"
									>
										{{ totalRuntime }} sec
									</th>
								</tr>
								<br />
								<tr data-height="20">
									<th
										data-f-bold="true"
										data-a-h="left"
										scope="col"
										style="width: 60%"
									>
										Title
									</th>
									<th
										data-f-bold="true"
										data-a-h="left"
										scope="col"
										style="width: 40%; text-align: center"
									>
										Total runtime (seconds)
									</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(song, index) in songs" :key="index">
									<td data-a-h="left">
										{{ song.title }}
									</td>
									<td
										data-t="n"
										data-a-h="left"
										class="compact text-center"
									>
										{{ song.total_runtime }}
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="modal-body text-center" v-else>
						No data was found for the selected date range. Click on
						the calender icon above to change the range.
					</div>
					<div class="modal-footer">
						<button
							v-if="songs && songs.length"
							type="button"
							class="btn btn-secondary"
							data-dismiss="modal"
							@click.prevent="exportTableToExcel"
						>
							Export
						</button>
						<button
							type="button"
							class="btn btn-secondary"
							data-dismiss="modal"
						>
							Close
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import moment from "moment";
import TableToExcel from "@linways/table-to-excel";

export default {
	data() {
		return {
			songs: [],
			dates: {
				start: moment()
					.startOf("month")
					.format("YYYY-MM-DD" + "T00:00:00.000+01:00"),
				end: moment()
					.add(1, "days")
					.endOf("month")
					.format("YYYY-MM-DD" + "T00:00:00.000+01:00"),
			},
		};
	},
	methods: {
		fetchData() {
			axios
				.get(`/statistics/music${this.getDateQuery()}`)
				.then((response) => {
					this.songs = response.data || [];
				})
				.catch((error) => {
					console.error(error);
				});
		},
		getDateQuery() {
			if (this.hasDates) {
				return `?from=${this.dateFrom}&to=${this.dateTo}`;
			}

			return "";
		},
		changeDateEvent() {
			this.fetchData();
		},
		deleteDates() {
			this.$set(this.dates, "start", null);
			this.$set(this.dates, "end", null);
			this.changeDateEvent();
		},
		exportTableToExcel() {
			const table = this.$refs.songsTable;

			TableToExcel.convert(table, {
				name: "Music.xlsx",
				sheet: {
					name: "Songs",
				},
			});
		},
	},
	computed: {
		hasDates() {
			return this.dates.start && this.dates.end;
		},
		dateFrom() {
			return moment(this.dates.start).format("YYYY-MM-DD");
		},
		dateTo() {
			return moment(this.dates.end).format("YYYY-MM-DD");
		},
		totalRuntime() {
			return this.songs.length
				? this.songs.reduce((acc, next) => acc + next.total_runtime, 0)
				: 0;
		},
	},
	components: {
		DatePicker,
	},
	mounted() {
		this.fetchData();
	},
};
</script>

<style>
</style>
